module.exports = __webpack_public_path__ + "../resources/img/ic_scrolltop.c3b1a4e8.svg";